import React, { useState, useCallback } from 'react';
import { makeStyles } from 'tss-react/mui';
import EDIconButton from '../BaseComponents/Buttons/IconButton/EDIconButton';
import Dialog from '../BaseComponents/Dialog/EDDialog';
import Documents, {
  getDocumentUrl,
  IDocument,
} from '../Components/Documents/Documents';

interface IDocumentRaw {
  EXTENSION: string;
  BINARDATA: string;
  BESKRIVNING: string;
}

interface IProps {
  disabled?: boolean;
  hidden?: boolean;
  documents?: IDocumentRaw[];
}

const useStyles = makeStyles()(theme => ({
  dialogPaper: {
    width: '100%',
  },
  iconButton: {
    cursor: 'pointer',
    pointerEvents: 'all',
  },
}));

const FakturaDokumentViewIkon: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { classes } = useStyles();
  const [open, setOpen] = useState(false);

  const onClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.stopPropagation();
      setOpen(!open);
    },
    [open]
  );

  const documents: IDocument[] =
    props.documents?.map(document => {
      const extension: string = document.EXTENSION?.toLowerCase() ?? '';

      return {
        url: getDocumentUrl(document.BINARDATA),
        extension: extension,
        fileName: document.BESKRIVNING || '',
      };
    }) ?? [];

  return !props.hidden ? (
    <>
      <EDIconButton
        onClick={onClick}
        icon="description"
        tooltip="Visa dokument"
        margin="dense"
        padding="dense"
        disabled={props.disabled}
        className={classes.iconButton}
      />
      <Dialog
        title="Dokument"
        open={open}
        onClose={() => setOpen(false)}
        footerActions={[{ label: 'Stäng', onClick: () => setOpen(false) }]}
        fullHeight
        classes={{ paper: classes.dialogPaper }}
        maxWidth="lg"
      >
        <Documents documents={documents} />
      </Dialog>
    </>
  ) : (
    <></>
  );
};

export default FakturaDokumentViewIkon;
